import { Document } from "../model/document.types"
import { faFile, faFileExcel, faFilePdf, faFileWord } from "@fortawesome/free-solid-svg-icons"

export function canOpenDocument(document: Document) {
  return !document.url
}

export function getPublicDocumentPath(document: Document, latestDuerpId?: string) {
  const establishmentId = document.EstablishmentId || document.content?.establishment?.id
  if (document.type === "duerp" && document.id === latestDuerpId && establishmentId) {
    return `/document/lastest?establishmentId=${establishmentId}`
  }
  return `/document/${document.id}`
}

export function formatDocumentDate(date: Date | string) {
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric"
  })
}

export function getUrlIcon(url: string) {
  const extension = url.split(".").pop()?.toLowerCase()

  if (extension === "pdf") return faFilePdf
  if (["xls", "xlsx"].includes(extension || "")) return faFileExcel
  if (["doc", "docx"].includes(extension || "")) return faFileWord
  return faFile
}

function getDocumentTitle(document: Document) {
  return document.type === "duerp" ? "document unique" : "papripact"
}

export function getDownloadFilename(document: Document) {
  const extension = document.url?.split(".").pop()?.toLowerCase()
  const name = `${getDocumentTitle(document)} ${formatDocumentDate(document.date)}`

  return extension ? `${name}.${extension}` : name
}

export async function downloadUrl(url: string, filename: string) {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = window.document.createElement("a")

    link.href = objectUrl
    link.download = filename
    window.document.body.appendChild(link)
    link.click()
    window.document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
  } catch {
    const link = window.document.createElement("a")

    link.href = url
    link.download = filename
    link.target = "_blank"
    window.document.body.appendChild(link)
    link.click()
    window.document.body.removeChild(link)
  }
}

export function openUrl(url: string) {
  const openedWindow = window.open(url, "_blank", "noopener,noreferrer")

  if (!openedWindow) {
    const link = window.document.createElement("a")
    link.href = url
    link.target = "_blank"
    link.rel = "noopener noreferrer"
    window.document.body.appendChild(link)
    link.click()
    window.document.body.removeChild(link)
  }
}
